module.exports = __webpack_public_path__ + "static/media/gallery1.13c64ab3.png";